import React from "react";
import { useTranslation } from "react-i18next";
import { HashLink as Link } from "react-router-hash-link";
import Logo from "../../atoms/Logo/Logo.component";
import Eyebrow from "../../atoms/Eyebrow/Eyebrow.styled";
import { getFooterLinks } from "../../../constants/navigation";
import { newLineText } from "../../../utils/utils";
import {
  ClosingDescription,
  ClosingSection,
  ClosingTitle,
  ClosingTop,
  ClosingWrapper,
  FooterBottom,
  FooterBrandLink,
  FooterCompany,
  FooterLinks,
} from "./LandingFooter.styled";

const LandingFooter = () => {
  const { t } = useTranslation();
  const footerLinks = getFooterLinks(t);

  return (
    <ClosingSection aria-labelledby="closing-title">
      <ClosingWrapper>
        <ClosingTop>
          <div>
            <Eyebrow light>{t("landing.closing.eyebrow")}</Eyebrow>
            <ClosingTitle id="closing-title">
              {newLineText(t("landing.closing.title")).map((line) => (
                <span key={line}>{line}</span>
              ))}
            </ClosingTitle>
            <ClosingDescription>
              {t("landing.closing.description")}
            </ClosingDescription>
          </div>
        </ClosingTop>
        <FooterBottom>
          <FooterBrandLink to="/" aria-label={t("landing.brand.home")}>
            <Logo width="108px" tagline={t("landing.brand.tagline")} />
          </FooterBrandLink>
          <FooterCompany>
            {newLineText(t("landing.footer.company")).map((line) => (
              <span key={line}>{line}</span>
            ))}
          </FooterCompany>
          <FooterLinks aria-label={t("landing.footer.contact")}>
            {footerLinks.map((item) => {
              if (item.href) {
                return (
                  <a key={item.title} href={item.href}>
                    {item.title}
                  </a>
                );
              }
              if (item.to) {
                return (
                  <Link key={item.title} to={item.to}>
                    {item.title}
                  </Link>
                );
              }
              return (
                <Link key={item.title} to={{ pathname: "/", hash: item.link }}>
                  {item.title}
                </Link>
              );
            })}
          </FooterLinks>
        </FooterBottom>
      </ClosingWrapper>
    </ClosingSection>
  );
};

export default LandingFooter;
